module.exports = __webpack_public_path__ + "img/tengxun-cloud.064813f2.svg";